import React from "react";
import { MLockProps } from "./types";
import { mobMainClsPrefix } from "../../../constants";
import { getLabel, weappSDK } from "@weapp/utils";
import { Button, Dialog, Spin } from "@weapp/ui";
import "./style/index.less"
import * as API from "../../../api/lock";

import logo from '../../../assets/pc_logo.png';
import { getQueryString } from "../../../utils";

const clsPrefix = `${mobMainClsPrefix}-mobile-lock-mask`;

const { message } = Dialog;

export class MUnlock extends React.Component<MLockProps> {

  state = {
    loading: false
  }

  render() {
    const { loading } = this.state;
    const isClient = getQueryString("client") || 'false';
    const device = getQueryString("device") || "";
    const userName = getQueryString("user") || "";
    return (
      <Spin weId={`${this.props.weId || ''}_7jdc41`} spinning={loading}>
        <div className={`${clsPrefix}`}>
          <div className={`${clsPrefix}-logo`}>
            <img src={logo} />
          </div>
          <div className={`${clsPrefix}-info-main`}>{getLabel('236238', '解锁 {0}', [isClient === "true" ? getLabel('236252', 'PC 客户端') : getLabel('236253', 'Web 端')])}</div>
          <div className={`${clsPrefix}-info-second`}>{getLabel('236254', '在 {0} 的 {1} 设备上解锁', [userName, device])}</div>
          <Button weId={`${this.props.weId || ''}_tkkfyg`}
            className={`${clsPrefix}-button`}
            type={"primary"}
            size={"large"}
            disabled={loading}
            onClick={() => {
              if (loading) {
                return;
              }
              this.setState({ loading: true });
              API.unlock(isClient).then(({ status, msg, data }) => {
                this.setState({ loading: false });
                if (status) {
                  message({ type: "success", content: getLabel('236255', '解锁成功') })
                  weappSDK?.customSDK?.invoke?.("unLock", {
                    data: { ...(isClient === "true" ? { "app-pc": { lockStatus: "NO_LOCK" } } : { "pc": { lockStatus: "NO_LOCK" } }) },
                    success: function (res: any) {}
                  });
                  setTimeout(() => {
                    weappSDK?.customSDK?.invoke?.("closeWindow", { success: function (res: any) {} });
                  }, 500)
                } else {
                  message({ type: "error", content: msg })
                }
              })
            }}>
            {getLabel('236256', '解锁')}
          </Button>
        </div>
      </Spin>
    );
  }
}